import React, { FC } from 'react';
import { ReactComponent as Representatives } from '../../../assets/MainMenu/Representatives.svg';

export const RepresentativesIcon: FC = () => <Representatives />;
